







































































































































































































































import Vue from "vue";
import {
    mdiSkipPrevious,
    mdiPlay,
    mdiPause,
    mdiSkipNext,
    mdiHeart,
    mdiHeartOutline,
    mdiShuffle,
    mdiRepeat,
    mdiRepeatOnce,
    mdiRepeatOff,
    mdiVolumeHigh,
    mdiDevices,
} from "@mdi/js";
import { RepeatState } from "@/structures/spotifyApi";

enum PlaybackControls {
    playpause = "playpause",
    skipNext = "skipNext",
    skipPrevious = "skipPrevious",
    saveUnsave = "saveUnsave",
    shuffle = "shuffle",
    repeat = "repeat",
    volume = "volume",
    devices = "devices",
}

export default Vue.extend({
    data() {
        return {
            mdiSkipPrevious,
            mdiPlay,
            mdiPause,
            mdiSkipNext,
            mdiHeart,
            mdiHeartOutline,
            mdiShuffle,
            mdiRepeat,
            mdiRepeatOnce,
            mdiRepeatOff,
            mdiVolumeHigh,
            mdiDevices,
            RepeatState,
            PlaybackControls,
        };
    },
    props: {
        currentlyPlaying: {
            type: Object || String,
            required: true,
        },
        artists: {
            type: String,
            required: true,
        },
        progress: {
            type: String,
            required: true,
            default: "--:--",
        },
        duration: {
            type: String,
            required: true,
            default: "--:--",
        },
        trackSaved: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    methods: {
        callHandler(control: PlaybackControls): void {
            this.$emit(control);
        },
    },
});
